import { forwardRef } from 'react'
import { DefaultSearchHeaderInput, Chip } from '../DefaultSearchHeaderInput'

type DefaultSearchTriggerProps = {
  className?: string
  placeholder?: string
  value?: string
  chips?: Chip[]
  onClick?: () => void
  onCancel?: () => void
}

export const DefaultSearchTrigger = forwardRef<
  HTMLDivElement,
  DefaultSearchTriggerProps
>(({ className, placeholder, value, chips = [], onCancel, onClick }, ref) => {
  return (
    <div ref={ref} className="cursor-pointer" onClick={onClick}>
      <DefaultSearchHeaderInput
        className={className}
        placeholder={placeholder}
        value={value}
        chips={chips}
        readOnly
        onCancel={onCancel}
      />
    </div>
  )
})

DefaultSearchTrigger.displayName = 'DefaultSearchTrigger'
